import { useState } from 'react';
import { InsuranceType } from '@weave/schema-gen-ts/dist/schemas/insurance-verification/shared/enums.pb';
import { ErrorBoundary } from '@frontend/error-boundary';
import { ErrorFallback } from '../components/error-fallback'; // Assuming this is your fallback component
import { InsuranceReportContainer } from '../containers/insurance-report-container';

type InsuranceReportPageProps = {
  reportProps: {
    locationId?: string;
    personInfo: {
      personId: string;
      personName: string;
    };
    sourceId?: string;
    personPMSId?: string;
    insuranceType?: InsuranceType;
    closeInsuranceReportModal?: () => void;
    onManagePayerConnection?: (payerId: string, payerWebsiteId: string) => void;
  };
};

const InsuranceReportPage = ({ reportProps }: InsuranceReportPageProps) => {
  const {
    locationId,
    personInfo,
    sourceId,
    personPMSId,
    insuranceType,
    closeInsuranceReportModal,
    onManagePayerConnection,
  } = reportProps;

  const [shouldShowErrorFallback, setShouldShowErrorFallback] = useState<boolean>(false);

  if (shouldShowErrorFallback) {
    return <ErrorFallback />;
  }

  return (
    <InsuranceReportContainer
      reportProps={{
        locationId: locationId as string,
        personInfo,
        sourceId: sourceId ?? '',
        personPMSId: personPMSId ?? '',
        insuranceType: insuranceType as InsuranceType,
        closeInsuranceReportModal,
        onError: () => setShouldShowErrorFallback(true),
        onManagePayerConnection,
      }}
    />
  );
};

export const InsuranceReportPageWithErrorBoundary = ({ reportProps }: InsuranceReportPageProps) => (
  <ErrorBoundary
    tier='feature'
    feature='insurance-eligibility-report-tuuthfairy.insurance-report-page'
    team='fe-rcm'
    fallback={<ErrorFallback />}
  >
    <InsuranceReportPage reportProps={reportProps} />
  </ErrorBoundary>
);
